import * as R from "ramda";

import {
  inlineHTMLToJSON,
  inlineJSONToHTML,
} from "../convert";

import {
  modifyNodeValueByUIDAndKey,
} from "../doc_helpers";

import {
  replaceText,
  addStyle,
  removeStyle,
} from "../inline_json";

export function handleTextInsert<DocContent extends PossibleContent>(
  newText: string,
  modifyContent: (modifyFunction: ModifyFunction<DocContent>) => void,
  setCurrentlyEditing: (currentlyEditing: CurrentlyEditing | undefined) => void,
  currentlyEditingOverride?: CurrentlyEditing,
) {
  modifyContent((json, currentlyEditing) => {
    const currentSelection = currentlyEditingOverride || currentlyEditing;
    if (!currentSelection || !currentSelection.range) { return json; }

    const newEndIndex = currentSelection.range.start + newText.length;

    setCurrentlyEditing({...currentSelection, range: {start: newEndIndex, end: newEndIndex}, newlyActiveStyles: [], newlyInactiveStyles: []});

    return modifyNodeValueByUIDAndKey(json, currentSelection.uid, currentSelection.key, (inlineHTML: InlineHtmlContent) => {
      let newInlineJSON = replaceText(inlineHTMLToJSON(inlineHTML), currentSelection.range, newText);

      const styleChangeRange = {
        start: currentSelection.range.start,
        end: currentSelection.range.start + newText.length,
      };

      if (currentSelection.newlyActiveStyles) {
        currentSelection.newlyActiveStyles.forEach((newActiveStyle) => {
          newInlineJSON = addStyle(newInlineJSON, newActiveStyle, styleChangeRange);
        });
      }

      if (currentSelection.newlyInactiveStyles) {
        currentSelection.newlyInactiveStyles.forEach((newInactiveStyle) => {
          newInlineJSON = removeStyle(newInlineJSON, newInactiveStyle.type, styleChangeRange);
        });
      }

      return inlineJSONToHTML(newInlineJSON);
    });

  });
}


export function handleDataTransferInsert<DocContent extends PossibleContent>(
  dataTransfer: DataTransfer,
  modifyContent: (modifyFunction: ModifyFunction<DocContent>) => void,
  setCurrentlyEditing: (currentlyEditing: CurrentlyEditing | undefined) => void,
  currentlyEditingOverride?: CurrentlyEditing,
) {
  const transferData = dataTransfer.getData("text/plain");

  if (transferData) {
    const newText = R.join(" ", R.reject(R.isEmpty, R.map(R.trim, (R.split("\n", transferData)))));

    handleTextInsert(
      newText,
      modifyContent,
      setCurrentlyEditing,
      currentlyEditingOverride,
    );
  }
}

